import $ from "jquery"
import '.././less/plugin-story.less';

import FluxEditorEvents from '../events';
import FluxEditorTooltip from '../tooltip';
import editTemplate from 'raw-loader!.././templates/story-edit-widget.html'
import widgetTemplate from 'raw-loader!.././templates/story-widget.html'

function FluxEditorStory(options) {
  this.defaults = {
    editTemplate: editTemplate,
    widgetTemplate: widgetTemplate,
    selectors: ['figure[class~="flux-story"]'],
    identifier: 'flux-editor-story',
    tooltipItemTitle: 'Embed story',
    linkPlaceholder: 'Copy/paste your link here and press enter.',
    events: {
      onNewElement: function(args ) { return args }
    }
  };
  this.settings = Object.assign({}, this.defaults, options);

  FluxEditorEvents(this);
  this.registerEvents();
}

FluxEditorStory.prototype.getSelectors = function() {
  return this.settings.selectors;
}

FluxEditorStory.prototype.getIdentifier = function() {
  return this.settings.identifier;
}

FluxEditorStory.prototype.registerEvents = function() {
  var _this = this;
  if (typeof this.settings.events == 'object') {
    $.each(this.settings.events, function(i,  f) {
      _this.on(i, f);
    });
  }
}

FluxEditorStory.prototype.getTooltipItem = function(context) {
  return {
    title: this.settings.tooltipItemTitle,
    className: 'flux-editor-story-tooltip-item',
    plugin: this,
    method: 'addNewElement',
    arguments: context
  }
}

FluxEditorStory.prototype.addNewElement = function(args) {
  this.emit('onNewElement', {
    plugin: this,
    fluxElementIndex: args.fluxElementIndex,
    core: args.core
  });
}

FluxEditorStory.prototype.insertNewElement = function(properties, index, core) {
  if (properties.heading) {
    core.insertNewEditableContentAfter(index, this, {
      heading: properties.heading,
      excerp: properties.excerp,
      image: properties.image,
      canonical_url: properties.canonical_url,
    });
  }
}

FluxEditorStory.prototype.getContent = function(el) {
  var $img = $(el).find('img');
  var $heading = $(el).find('.flux-story-heading');
  var $excerp = $(el).find('.flux-story-excerp');
  var $a = $(el).find('a');

  return {
    heading: $heading.html() ? $heading.html() : null,
    excerp: $excerp.html() ? $excerp.html() : null,
    image: $img.attr('src'),
    canonical_url: $a.attr('href') ? $a.attr('href') : null
  }
}

FluxEditorStory.prototype.getHTML = function(content, core) {
  this.___code = core
  var $figure = $(this.settings.widgetTemplate);

  var $img = $figure.find('img');
  var $a = $figure.find('a');
  var $heading = $figure.find('.flux-story-heading');
  var $excerp = $figure.find('.flux-story-excerp');

  $img.attr('src', content.image)
  $a.attr('href', content.canonical_url)
  $heading.html(content.heading)
  $excerp.html(content.excerp)

  return $figure[0].outerHTML;
}

FluxEditorStory.prototype.getEditableElement = function(content, core) {
  var $figure = $(this.settings.editTemplate);
  var $img = $figure.find('img');
  var $heading = $figure.find('.flux-story-heading');
  var $excerp = $figure.find('.flux-story-excerp');
  var $a = $figure.find('a');

  $img.attr('src', content.image)
  $a.attr('href', content.canonical_url)
  $heading.html(content.heading)
  $excerp.html(content.excerp)

  $figure.click(function (){
    var tooltip = new FluxEditorTooltip();

    // move
    tooltip.addItem({
      className: 'flux-editor-story-tooltip-arrowup',
      callback: function () {
        core.moveEditableContent(content.fluxElementIndex, 'up');
      }
    });
    tooltip.addItem({
      className: 'flux-editor-story-tooltip-arrowdown',
      callback: function () {
        core.moveEditableContent(content.fluxElementIndex, 'down');
      }
    });

    // remove
    tooltip.addItem({
      className: 'flux-editor-story-tooltip-trash',
      callback: function () {
        core.deleteEditableContent(content.fluxElementIndex);
      }
    });

    tooltip.display(
      $figure.offset().top + ($figure.outerHeight() - 50),
      $figure.offset().left + ($figure.outerWidth() / 2),
      true
    );
  })

  return $figure;
}

export default FluxEditorStory;
